import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  generateSearchFormItem,
  getGameTreeData,
} from "../../../../../utils/helper";
import { SearchAccordion } from "../../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({
  filter,
  setFilter,
  fixedFilter,
  gameInfos = [],
}: ISearchProps) => {
  const { t, i18n } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        enableReinitialize={true}
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          console.log(values);
          setFilter({ ...values, pages: 0, ...fixedFilter });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.Time",
                },
                {
                  type: "text",
                  name: "transactionID",
                  label: "LobbyCompetitiveGameRecord.transactionID",
                  disable: Boolean(
                    form.values.fakeID !== "" || form.values.gameIDs?.length
                  ),
                },
                {
                  type: "multiSelect",
                  name: "gameIDs",
                  label: "LobbyCompetitiveGameRecord.gameID",
                  treeData: getGameTreeData(gameInfos, i18n.language),
                  disable: form.values.transactionID !== "",
                },
                {
                  type: "number",
                  name: "fakeID",
                  label: "LobbyCompetitiveGameRecord.fakeID",
                  disable: form.values.transactionID !== "",
                },
              ].filter((v) => {
                // 過濾掉固定的搜尋條件
                return !(
                  fixedFilter &&
                  Object.keys(fixedFilter).find((key) => key === v.name)
                );
              }) as any,
              defaultFilter(),
              t
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
